import React from "react";
import Image from "gatsby-image";
import { getImage } from "~/helpers";
import { CenteredContainer } from "~/components/.base/containers";
import border from "~/images/background/border_white.png";
import styled from "styled-components";
const HeroContainer = styled(CenteredContainer)`
	width: 100%;
	height: ${(props) => props.size};
	position: relative;
	background-size: cover;
	background-position: center;
	${(props) =>
		props.size && props.image
			? `background-image: url(${props.image});`
			: `.hero-img {
				width: 100%; height: auto;
			}`}
	.gatsby-image-wrapper {
		width: 100%;
	}
	.border {
		position: absolute;
		width: 100%;
		bottom: -25px;
		left: 0;
	}
	.hero-details {
		${(props) => (props.size ? "" : "position: absolute;")}
		width: 100%;
		z-index: 2;
		h1,
		h3,
		p {
			color: #fff;
			text-align: center;
			max-width: 600px;
			margin: auto;
			margin-bottom: 1rem;
		}
	}
	.cont {
		z-index: 2;
	}
	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.3);
	}
	@media screen and (max-width: 768px) {
		${(props) =>
			!props.size && props.image
				? `background-image: url(${props.image});
				height: 70vh;
				background-size: cover;
				.hero-img {
					display: none;
				}`
				: ``}
		${(props) =>
			props.imageFluid
				? `background-image: url(${props.imageFluid.src});
				height: 70vh;
				background-size: cover;
				.gatsby-image-wrapper {
					display: none;
				}`
				: ``}
		.border {
			bottom: -5px;
		}
	}
`;
const Hero = ({
	size,
	image,
	imageFluid,
	alt,
	wrapperClass,
	children,
	noOverlay,
}) => {
	console.log(imageFluid);
	if (imageFluid) {
		return (
			<HeroContainer className={wrapperClass} imageFluid={imageFluid}>
				{!noOverlay ? <div className="overlay" /> : null}
				<Image fluid={imageFluid} alt={alt} />
				<img className="border" src={border} alt="border" />
				{children}
			</HeroContainer>
		);
	} else {
		return (
			<HeroContainer
				className={wrapperClass}
				size={size === "full" ? "calc(100vh - 96px)" : null}
				image={image}
			>
				{!noOverlay ? <div className="overlay" /> : null}
				{size !== "full" ? (
					<img className="hero-img" src={image} alt={alt} />
				) : null}
				<img className="border" src={border} alt="border" />
				{children}
			</HeroContainer>
		);
	}
};

export default Hero;
